module.exports = __webpack_public_path__ + "img/banner2.bf152a0c.jpg";